import R from 'ramda';

export const initialStepState = {
  completed: false,
  loadingInitData: true,
  loadingLocalStorage: true,
  errors: {},
  fields: {},
};

export const completedLens = R.lensProp('completed');
export const setCompleted = R.set(completedLens);
export const getCompleted = R.view(completedLens);

export const loadingLocalStorageLens = R.lensProp('loadingLocalStorage');
export const setLoadingLocalStorage = R.set(loadingLocalStorageLens);
export const getLoadingLocalStorage = R.view(loadingLocalStorageLens);

export const loadingInitDataLens = R.lensProp('loadingInitData');
export const setLoadingInitData = R.set(loadingInitDataLens);
export const getLoadingInitData = R.view(loadingInitDataLens);

export const getLoading = R.anyPass([
  getLoadingLocalStorage,
  getLoadingInitData,
]);

export const errorsLens = R.lensProp('errors');
export const setErrors = R.set(errorsLens);
export const getErrors = R.view(errorsLens);
export const hasErrors = R.pipe(getErrors, R.complement(R.isEmpty));

export const fieldsLens = R.lensProp('fields');
export const setFields = R.set(fieldsLens);
export const getFields = R.view(fieldsLens);
export const setFieldValue = R.curry((path, value, state) =>
  R.set(R.lensPath(['fields', ...path]), value, state),
);

export const completeStep = (validator, state) => {
  const errors = validator(getFields(state));

  return R.pipe(
    setErrors(R.isNil(errors) ? {} : errors),
    setCompleted(R.isNil(errors)),
  )(state);
};



// WEBPACK FOOTER //
// ./src/common/stepReducerUtil.js